import { render, staticRenderFns } from "./DrugRouteSelect.vue?vue&type=template&id=c2cb771c&"
import script from "./DrugRouteSelect.vue?vue&type=script&lang=js&"
export * from "./DrugRouteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports